import {
  Centred,
  Contents,
  LinkText,
  MainFloat,
  Margins,
  RichText,
  Btn,
  Page,
} from '../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  contents: {
    ...Contents(theme),
  },
  mainFloat: {
    ...MainFloat(theme),
    marginTop: '-30%',
    position: 'relative',
  },
  margins: {
    ...Margins(theme),
  },
  btn: {
    ...Btn(theme),
  },
  linkText: {
    ...LinkText(theme),
  },
  richText: {
    ...RichText(theme),
  },
  page: {
    ...Page(theme),
  },
   boxes: {
    marginTop: theme.spacing.unit * 10,
    marginBottom: theme.spacing.unit * 5,
  },
  boxesTitle: {
    color: '#D3407E',
    fontSize: theme.typography.headline.fontSize,
    fontWeight: 800,
    lineHeight: 0.9,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.headline.fontSize,
      wordBreak: 'break-word',
    },
  },
  boxesSubtitle: {
    textTransform: 'uppercase',
    fontSize: theme.typography.caption.fontSize,
  },
  flipper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100% !important',
    },
  },
  flipperRow: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  flipperColumn: {
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      maxWidth: '75% !important',
      margin: 30,
    },
  },
  boxTitle: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    textTransform: 'uppercase',
    fontSize: theme.typography.subheading.fontSize,
    fontWeight: 800,
    lineHeight: 0.9,
  },
  boxLead: {
    fontSize: 18,
    lineHeight: 1.1,
    height: 95,
    overflowY: 'hidden',
  },
  boxBack: {
    padding: 10,
  },
  boxFront: {
    padding: 10,
  },
  boxButton: {
    fontSize: 14,
  },
  boxDescription: {
    fontSize: 15,
    lineHeight: 1.1,
    color: '#fff',
    padding: 20,
    height: 165,
    overflowyY: 'hidden',
    marginBottom: 15,
  },
  boxButtonIcon: {
    borderRadius: 100,
    color: '#333',
    height: 20,
    width: 20,
    fontSize: 22,
    marginRight: 10,
  },
  boxButtonOn: {
    background: 'green',
  },
  boxButtonOff: {
    background: '#fff',
  },
  cornerOn: {
    position: 'absolute',
    height: 50,
  },
  cornerOff: {
    display: 'none',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/boxes/styles.js